// @flow

import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Auth from './containers/Auth';
import PendingSketchOrders from './containers/QueuedSketchOrders';
import PendingSketchOrdersVendor from './containers/QueuedVendorSketchOrders';
import ProtectedRoute from './containers/ProtectedRoute';
import AllSketchOrders from './containers/AllSketchOrders';
import Dashboard from './containers/Dashboard';
import MyAssignedSketchOrders from './containers/MyAssignedSketchOrders';
import NoMatch from './components/NoMatch/NoMatch';
import SketchOrder from './containers/SketchOrder/SketchOrder';
import SketchRoute from './containers/SketchComponentHost/SketchRoute';
import MapImageryOptionsHost from './containers/MapImageryOptionsHost/MapImageryOptionsHost';
import SearchSketchOrders from './containers/SearchSketchOrders/SearchSketchOrders';

type RouterProvidedProps = {
    location: {
        pathname: String,
    }
};

class Content extends Component<RouterProvidedProps> {
    getMainStyle = () => {
        const mainStyle = {
            padding: 24,
            paddingTop: 24,
            height: '100%',
        };

        if (this.props.location.pathname === '/') {
            mainStyle.paddingTop = 100;
        } else {
            mainStyle.paddingTop = 175;
        }

        return mainStyle;
    }

    render() { 
        const mainStyle = this.getMainStyle();
        return (
            <main
                style={mainStyle}
            >
                <Switch>
                    <Route exact path="/login" component={Auth} />
                    <ProtectedRoute exact path="/" component={Dashboard} />
                    <ProtectedRoute exact path="/orders" component={AllSketchOrders} sketchOsAdminRequired />
                    <ProtectedRoute exact path="/queue" component={PendingSketchOrders} />
                    <ProtectedRoute exact path="/queue/vendor" component={PendingSketchOrdersVendor} />
                    <ProtectedRoute exact path="/myorders" component={MyAssignedSketchOrders} />
                    <ProtectedRoute exact path="/orders/:id" component={SketchOrder} />
                    <ProtectedRoute exact path="/orders/:id/imagery" component={MapImageryOptionsHost} />
                    <ProtectedRoute exact path="/orders/:id/sketch/:projectId" component={SketchRoute} />
                    <ProtectedRoute exact path="/searchorders" component={SearchSketchOrders} sketchOsAdminRequired />
                    <Route component={NoMatch} />
                </Switch>
            </main>
        );
    }
}
 
export default withRouter(Content);